import * as Sentry from "@sentry/react";

const dsn =
  "https://a8e7e4e89b972bf90d1b65d35465b353@o4509703264665600.ingest.de.sentry.io/4509713125605456";

export default function initSentry(debug = false) {
  debug && console.warn("Sentry debug active");

  const enabledEnvs =
    import.meta.env.PROD && import.meta.env.VITE_ENV !== "development";

  if (debug || enabledEnvs) {
    Sentry.init({
      dsn,
      debug,
      beforeSend(event, hint) {
        const original = hint.originalException;
        const message =
          (typeof original === "string" && original) ||
          original?.message ||
          event?.exception?.values?.[0]?.value ||
          "";
        if (
          message.includes("Load failed") ||
          message.includes("Failed to fetch")
        ) {
          return null;
        }
        return event;
      },
      beforeBreadcrumb: (breadcrumb) => {
        if (
          breadcrumb.category === "error" &&
          breadcrumb.message?.includes("NetworkError")
        ) {
          debug && console.log("Filtered `NetworkError` entry", breadcrumb);
          return null;
        }

        if (breadcrumb.category === "ui.click" && breadcrumb.message) {
          const selector = breadcrumb.message;
          const idMatch = selector.match(/#([a-zA-Z0-9_-]+)/);

          if (idMatch && idMatch[1]) {
            const elementId = idMatch[1];
            breadcrumb.message = `Clicked element with ID: #${elementId} | Original message: (${selector})`;
            breadcrumb.data = {
              ...breadcrumb.data,
              elementId,
            };
          }
        }

        debug && breadcrumb.category === "ui.click" && console.log(breadcrumb);

        return breadcrumb;
      },
    });
  }
}
